import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import setCardInState from '../../utils/cardStateStorage/setCardInState';
import getCardFromState from '../../utils/cardStateStorage/getCardFromState';
import {OutputType} from 'common/src/modules/nodes/nodes.types';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {DateTime} from 'luxon';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {conditionOutputSchema} from '../../promptToCardAgentV2.types';

const addConditionOutputToolSchema = z.object({
  conditionOutput: conditionOutputSchema.extend({
    name: z.string().describe('The name of the output'),
  }),
});

export default function addConditionOutputTool() {
  async function execute(params: ToolExecuteParams<typeof addConditionOutputToolSchema>) {
    const {conditionOutput} = params.input;

    const currentCard = getCardFromState();

    const indexOfLastRegularOutput = currentCard.outputs.findIndex(
      (output) => output.type === OutputType.Regular,
    );

    currentCard.outputs.splice(indexOfLastRegularOutput + 1, 0, {
      id: currentCard.outputs.length + 1,
      nodeId: NO_NODE_ID,
      name: conditionOutput.name,
      type: OutputType.Regular,
      ...(conditionOutput.textValues && {textValues: conditionOutput.textValues}),
      ...(conditionOutput.numericValues && {numericValues: conditionOutput.numericValues}),
      ...(conditionOutput.booleanValue && {booleanValue: conditionOutput.booleanValue}),
      ...(conditionOutput.dateValues && {
        dateValues: conditionOutput.dateValues.map((date) => DateTime.fromISO(date)),
      }),
      ...(conditionOutput.datesRange && {
        datesRange: {
          from: DateTime.fromISO(conditionOutput.datesRange.from),
          to: DateTime.fromISO(conditionOutput.datesRange.to),
        },
      }),
      ...(conditionOutput.numbersRange && {
        numbersRange: {
          from: conditionOutput.numbersRange.from,
          to: conditionOutput.numbersRange.to,
        },
      }),
      booleanValue: conditionOutput.booleanValue,
    });

    setCardInState(currentCard);

    return toolResult('Condition output added');
  }

  return tool({
    name: V2CardAgentToolName.AddConditionOutput,
    displayName: 'Adding condition output',
    description: 'Add a condition output to a condition card',
    inputSchema: addConditionOutputToolSchema,
    execute,
  });
}
